<template>
    <AdminNextIframe
        :path="`/parameters/${$route.params.subPath || ''}`"
        :query="{ clientId: $route.params.id }"
        :full-view="false"
        @navigate="onNavigate"
        @back="onBack" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientParameters',
    components: { AdminNextIframe },
    methods: {
        onNavigate(path) {
            const match = path.match(/^\/parameters\/?(.*)$/);
            if (!match) return;
            const subPath = match[1] || undefined;
            this.$router.replace({
                name: 'client-parameters',
                params: { ...this.$route.params, subPath }
            }).catch(() => {});
        },
        onBack() {
            this.$router.push({
                name: 'client',
                params: { id: this.$route.params.id }
            });
        }
    }
}
</script>
